'use client'

import { CompatibleFilterCard, type CompatibleFilterItem } from '@/components/brand-kit/compatible-filter-card'
import { getFilterHubSlugForBrand } from '@/lib/filter-hub-slugs'

interface CompatibleFilterSectionProps {
  filters: CompatibleFilterItem[]
  fridgeBrand: string
  /**
   * FRIDGE-853 — every compatible filter this appliance has that could render,
   * not just the ones passed in. Defaults to `filters.length`, which makes the
   * coverage line disappear rather than assert a total nobody measured.
   */
  totalFilters?: number
}

export function CompatibleFilterSection({ filters, fridgeBrand, totalFilters }: CompatibleFilterSectionProps) {
  if (!filters || filters.length === 0) return null
  const filterHubSlug = getFilterHubSlugForBrand(fridgeBrand)

  return (
    <CompatibleFilterCard
      filters={filters}
      fridgeBrand={fridgeBrand}
      filterHubSlug={filterHubSlug}
      totalFilters={totalFilters ?? filters.length}
    />
  )
}
